var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$router.currentRoute.meta.layout,{tag:"component"},[_c('router-view',{key:_vm.$router.currentRoute.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }